<template>
  <MainLayout>
    <Head>
      <title>{{ title }}</title>
    </Head>
    <template v-slot:header>
      {{ title }}
    </template>

    <FormWrapper grid>
      <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4">Find Part</h3>

      <form @submit.prevent="submit">
        <FormInput name="name"
                   :show-label="false"
                   v-model="form.search"
                   :errors="errors"
                   class="sm:col-span-6"/>

        <FormActions :cancelUrl="$route('builds.index')"
                     submitLabel="Search"
                     grid />
      </form>
    </FormWrapper>

    <DataTable class="mt-4" v-if="parts.length">
      <template v-slot:header>
        <th scope="col" class="">
          SKU
        </th>
        <th scope="col">
          Price
        </th>
        <th scope="col">
          <span class="sr-only">Choose</span>
        </th>
      </template>

      <tr v-for="part in parts" :key="part.id">
        <td>{{ part.sku }}</td>
        <td>${{ part.retail_price }}</td>
        <td>
          <Link :href="$route('builds.create', { ...selectedOptions, part_id: part.id })" class="text-indigo-600 hover:text-indigo-900">Choose</Link>
        </td>
      </tr>
    </DataTable>
  </MainLayout>
</template>

<script>
import SelectCommon from './select-common'

export default {
  extends: SelectCommon,

  props: {
    parts: Array,
  },

  methods: {
    getSelectedOptions() {
      const { part_id, ...selectedOptions } = this.selectedOptions
      return selectedOptions
    },
  }
}
</script>
